"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StandardButton = exports.PrimaryButton = exports.NeutralButton = exports.NeutralBorderlessButton = exports.LinkButton = exports.DestructiveButton = exports.Button = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _buttonModule = _interopRequireDefault(require("./button.module.scss"));
var _excluded = ["level", "tag", "type", "children", "className", "disabled", "inline", "small", "onClick", "large", "tabIndex", "innerRef"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children"],
  _excluded5 = ["children"],
  _excluded6 = ["children"],
  _excluded7 = ["children", "underlined", "className"];
var defaultProps = {
  tag: 'button',
  children: '',
  className: undefined,
  type: 'button',
  level: 'standard',
  small: false,
  disabled: false,
  inline: false
};
var Button = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classNames;
  var level = props.level,
    tag = props.tag,
    type = props.type,
    children = props.children,
    className = props.className,
    disabled = props.disabled,
    inline = props.inline,
    small = props.small,
    onClick = props.onClick,
    large = props.large,
    tabIndex = props.tabIndex,
    _props$innerRef = props.innerRef,
    innerRef = _props$innerRef === void 0 ? ref : _props$innerRef,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = (0, _classnames.default)(_buttonModule.default.btn, (_classNames = {}, (0, _defineProperty2.default)(_classNames, _buttonModule.default["btn--".concat(level)], !!level), (0, _defineProperty2.default)(_classNames, _buttonModule.default['btn--disabled'], disabled), (0, _defineProperty2.default)(_classNames, _buttonModule.default['btn--inline'], inline), (0, _defineProperty2.default)(_classNames, _buttonModule.default['btn--small'], small === true), (0, _defineProperty2.default)(_classNames, _buttonModule.default['btn--large'], large === true), _classNames), (0, _defineProperty2.default)({}, _buttonModule.default[className], className && !!_buttonModule.default[className]), (0, _defineProperty2.default)({}, className, !_buttonModule.default[className] && !!className));
  return /*#__PURE__*/_react.default.createElement("button", Object.assign({}, rest, {
    className: classes,
    type: type,
    onClick: onClick,
    disabled: disabled,
    tabIndex: tabIndex,
    ref: innerRef
  }), children);
});
exports.Button = Button;
var PrimaryButton = function PrimaryButton(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded2);
  return /*#__PURE__*/_react.default.createElement(Button, Object.assign({
    level: "primary"
  }, rest), children);
};
exports.PrimaryButton = PrimaryButton;
var StandardButton = function StandardButton(_ref2) {
  var children = _ref2.children,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded3);
  return /*#__PURE__*/_react.default.createElement(Button, Object.assign({
    level: "standard"
  }, rest), children);
};
exports.StandardButton = StandardButton;
var NeutralButton = function NeutralButton(_ref3) {
  var children = _ref3.children,
    rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded4);
  return /*#__PURE__*/_react.default.createElement(Button, Object.assign({
    level: "neutral"
  }, rest), children);
};
exports.NeutralButton = NeutralButton;
var NeutralBorderlessButton = function NeutralBorderlessButton(_ref4) {
  var children = _ref4.children,
    rest = (0, _objectWithoutProperties2.default)(_ref4, _excluded5);
  return /*#__PURE__*/_react.default.createElement(Button, Object.assign({
    level: "neutral-borderless"
  }, rest), children);
};
exports.NeutralBorderlessButton = NeutralBorderlessButton;
var DestructiveButton = function DestructiveButton(_ref5) {
  var children = _ref5.children,
    rest = (0, _objectWithoutProperties2.default)(_ref5, _excluded6);
  return /*#__PURE__*/_react.default.createElement(Button, Object.assign({
    level: "destructive"
  }, rest), children);
};
exports.DestructiveButton = DestructiveButton;
var LinkButton = function LinkButton(_ref6) {
  var children = _ref6.children,
    underlined = _ref6.underlined,
    className = _ref6.className,
    rest = (0, _objectWithoutProperties2.default)(_ref6, _excluded7);
  return /*#__PURE__*/_react.default.createElement(Button, Object.assign({
    level: "link",
    className: (0, _classnames.default)(className, (0, _defineProperty2.default)({}, _buttonModule.default['btn--underlined'], !!underlined))
  }, rest), children);
};
exports.LinkButton = LinkButton;
Button.defaultProps = defaultProps;